import { ReactComponent as HotbarIcon } from "@assets/images/Hotbar.svg";
import CloseIcon from "@mui/icons-material/Close";
import React, { useState } from "react";
import {
  Content,
  Header,
  HotbarContainer,
  TabsWrapper,
  Title,
  TitleWithIcon,
} from "./NewHotbar.styled";
import TabNavigation from "./TabNavigation";
import AudiosTab from "./Tabs/AudiosTab";
import DocumentsTab from "./Tabs/DocumentsTab";
import ImagesTab from "./Tabs/ImagesTab";
import LinksTab from "./Tabs/LinksTab";
import VideosTab from "./Tabs/VideosTab";
import useScreenSize from "../../hooks/useScreenSize";

const NewHotbar = ({ isOpen, onClose, onSegmentOpen }) => {
  const [activeTab, setActiveTab] = useState("images");
  const { isMobilePortrait} = useScreenSize();

  const renderTabContent = () => {
    switch (activeTab) {
      case "images":
        return <ImagesTab onSegmentOpen={onSegmentOpen} />;
      case "videos":
        return <VideosTab onSegmentOpen={onSegmentOpen} />;
      case "documents":
        return <DocumentsTab onSegmentOpen={onSegmentOpen} />;
      case "audios":
        return <AudiosTab onSegmentOpen={onSegmentOpen} />;
      case "links":
        return <LinksTab onSegmentOpen={onSegmentOpen} />;
      default:
        return <ImagesTab onSegmentOpen={onSegmentOpen} />;
    }
  };

  return (
    <HotbarContainer isOpen={isOpen} isMobilePortrait={isMobilePortrait}>
   {!isMobilePortrait &&    <Header>
        <TitleWithIcon>
          <HotbarIcon style={{ width: "30px", height: "30px" }} />
          <Title>Hotbar</Title>
        </TitleWithIcon>
        <CloseIcon onClick={onClose} style={{ cursor: "pointer" }} />
      </Header>}
        <>
          <TabsWrapper>
            <TabNavigation activeTab={activeTab} onChangeTab={setActiveTab} />
          </TabsWrapper>
          <Content>{renderTabContent()}</Content>
        </>
    
    </HotbarContainer>
  );
};

export default NewHotbar;
